import { client } from '@/lib/api/client'
import { venueCourtPath, venueCourtsPath } from '@/lib/api/config'
import { toApiError } from '@/lib/api/errors'

import type { CourtListView, CourtSaveInput } from './courtTypes'

/**
 * `GET .../courts` (#597 §1).
 * 🚨 게이팅 대상이 아니다 — 이용권이 모두 만료돼도 항상 200(무엇이 잠겼는지는 `editable` 로 안다).
 */
export async function fetchCourts(venueId: string): Promise<CourtListView> {
  try {
    const { data } = await client.get<CourtListView>(venueCourtsPath(venueId))
    return data
  } catch (error) {
    throw toApiError(error)
  }
}

/**
 * `POST .../courts` (#597 §2).
 * 응답은 등록 후 최신 목록(§1 과 동일한 View) — 화면이 재조회하지 않는다.
 */
export async function createCourt(venueId: string, input: CourtSaveInput): Promise<CourtListView> {
  try {
    const { data } = await client.post<CourtListView>(venueCourtsPath(venueId), input)
    return data
  } catch (error) {
    throw toApiError(error)
  }
}

/**
 * `PUT .../courts/{courtId}` (#597 §3).
 * 🚨 전량 교체 — `input` 의 모든 필드를 그대로 보낸다.
 */
export async function updateCourt(
  venueId: string,
  courtId: number,
  input: CourtSaveInput
): Promise<CourtListView> {
  try {
    const { data } = await client.put<CourtListView>(venueCourtPath(venueId, courtId), input)
    return data
  } catch (error) {
    throw toApiError(error)
  }
}

/**
 * `DELETE .../courts/{courtId}` (#597 §4).
 * 🚨 소프트 삭제 — 앞으로 이용할 예약이 남아 있으면 409(봉투에 `blockReason` 없음).
 */
export async function deleteCourt(venueId: string, courtId: number): Promise<CourtListView> {
  try {
    const { data } = await client.delete<CourtListView>(venueCourtPath(venueId, courtId))
    return data
  } catch (error) {
    throw toApiError(error)
  }
}
